
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/white-labelling",
      function () {
        return require("private-next-pages/resources/white-labelling.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/white-labelling"])
      });
    }
  